// import React, { useEffect, useState, useMemo, useCallback } from "react";
// import { Link } from "react-router-dom";
// import TripDetailsCard from "./TripDetailsCard";
// import { fetchAllvehicle, vehicleSelector } from "../api/vehicles";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchoneroute_details, routeSelector } from "../api/route";
// import { fetchpricingmodal, pricingSelector } from "../api/pricesetting";
// import axios from "axios";
// import { KeyUri } from "../key";

// const CarList = () => {
//   // Memoize retrievedData so it doesn't change on every render
//   const [retrievedData] = useState(() =>
//     JSON.parse(localStorage.getItem("Selected Data"))
//   );
//   const { all_vehicle } = useSelector(vehicleSelector);
//   const { current_route } = useSelector(routeSelector);
//   const { currentPricing } = useSelector(pricingSelector);
//   const dispatch = useDispatch();

//   const [tripdata, set_trip_data] = useState([]);
//   const [ride_date, set_ride_date] = useState();
//   const [activeTab, setActiveTab] = useState("shared");
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "ascending" });
//   const [pricing_obj, setPricing_obj] = useState({});

//   // Run once on mount
//   useEffect(() => {
//     if (!retrievedData) return;
//     dispatch(fetchAllvehicle());
//     dispatch(fetchoneroute_details(retrievedData));
//     dispatch(fetchpricingmodal());
//     const formattedDate = new Date(retrievedData?.date).toISOString();
//     set_ride_date(formattedDate);
//   }, [dispatch, retrievedData]);

//   // Fetch trip data when ride_date changes
//   useEffect(() => {
//     if (!ride_date) return;
//     const fetchTrip = async () => {
//       try {
//         const response = await axios.post(
//           `${KeyUri.BACKEND_URI}/get-full-cabs`,
//           { rideDate: ride_date }
//         );
//         set_trip_data(response.data.details || []);
//       } catch (error) {
//         console.error("Error fetching trip:", error.response?.data || error.message);
//       }
//     };
//     fetchTrip();
//   }, [ride_date]);

//   // Update pricing object when currentPricing changes
//   useEffect(() => {
//     setPricing_obj(currentPricing?.[0] || {});
//   }, [currentPricing]);

//   // Memoize getprice to avoid recreation
//   const getprice = useCallback(
//     (car) => {
//       if (!car || !pricing_obj || !current_route) return 0;
//       console.log("here is the route details ", current_route)
//       if (pricing_obj.pricing_model === "Driver Fixed") {
//         const perSeat =
//           Number(car.price_per_trip?.$numberDecimal) / (car.capacity - 1);
//         return perSeat + perSeat * (pricing_obj.platform_price / 100);
//       }
//       if (pricing_obj.pricing_model === "Admin Fixed") {
//         const key =
//           car.category === "Economy"
//             ? "price_for_economy"
//             : car.category === "Luxury"
//               ? "price_for_luxary"
//               : "price_for_premium";
//         const base = Number(current_route[key]?.$numberDecimal) || 0;
//         console.log("current base price for ", car?.brand_and_model_name," price is ", base)
//         return base + base * (pricing_obj.platform_price / 100);
//       }
//       return 0;
//     },
//     [pricing_obj, current_route]
//   );


//   // pricing for full cabs function 
//   const getprice_for_fullcabs = useCallback(
//     (car) => {
//       if (!car || !pricing_obj || !current_route) return 0;

//       if (pricing_obj?.pricing_model_for_fullcabs === "Driver Fixed") {
//         const perTrip = (Number(car?.price_per_km?.$numberDecimal) * current_route?.no_of_kms);
//         return perTrip * (1 + pricing_obj?.platform_price_for_full_cabs / 100);
//       }

//       if (pricing_obj?.pricing_model_for_fullcabs === "Admin Fixed") {
//         const key =
//           car.category === "Economy"
//             ? "full_cab_price_for_economy"
//             : car.category === "Luxury"
//               ? "full_cab_price_for_luxary"
//               : "full_cab_price_for_premium";
//         const base =
//           Number(current_route[key]?.$numberDecimal) * (1) || 0;
//                   console.log("current base price for ", car?.brand_and_model_name," price is ", base)

//         return base * (1 + pricing_obj.platform_price_for_full_cabs / 100);
//       }

//       return 0;
//     },
//     [pricing_obj, current_route]
//   );

//    const selectedDate = retrievedData?.date;
//    console.log("selected date  ===>", selectedDate)



// // Filter vehicles based on active tab
// // const filteredVehicles = useMemo(() => {
// //   if (!all_vehicle || !current_route || !selectedDate) return [];
// //   console.log("all vehicle ===>", all_vehicle)

// //   const selectedDateObj = new Date(selectedDate);

// //   // Check if vehicle is unavailable on the selected date
// //   const isUnavailable = (car) => {
// //     if (car.not_available) {
// //       const fromDate = new Date(car.not_available.from);
// //       const toDate = new Date(car.not_available.to);
// //       return selectedDateObj >= fromDate && selectedDateObj <= toDate;
// //     }
// //     return false;
// //   };

// //   if (activeTab === "shared") {
// //     return all_vehicle.filter((car) => {
// //       const sameRoute = car.route_id?._id === current_route._id;
// //       const categoryMatch = car.category === retrievedData?.seats;
// //       const sharedCab = car?.cab_available_for === 'Shared-cab' || car?.cab_available_for === 'Both';

// //       return sameRoute && categoryMatch && sharedCab && !isUnavailable(car);
// //     });
// //   }

// //   // Full cabs
// //   return all_vehicle.filter((car) => {
// //     const sameRoute = car.route_id?._id === current_route._id;
// //     const assigned = tripdata.some(
// //       (trip) => trip.vehicleId === car._id && trip.route === current_route._id
// //     );
// //     const fullCab = car?.cab_available_for === 'Full-Cab' || car?.cab_available_for === 'Both';
// //     const categoryMatch = car.category === retrievedData?.seats;

// //     return sameRoute && !assigned && fullCab && categoryMatch && !isUnavailable(car);
// //   });
// // }, [all_vehicle, current_route, activeTab, retrievedData, tripdata, selectedDate]);




// const filteredVehicles = useMemo(() => {
//   if (!all_vehicle || !current_route || !selectedDate) return [];

//   const selectedDateObj = new Date(selectedDate);

//   return all_vehicle
//     .filter((car) => {
//       const isSameRoute = car.route_id?._id === current_route._id;
//       const categoryMatch = car.category === retrievedData?.seats;

//       if (!isSameRoute || !categoryMatch) return false;

//       // Check if unavailable on selected date
//       const isUnavailable =
//         car.not_available &&
//         (() => {
//           const from = new Date(car.not_available.from);
//           const to = new Date(car.not_available.to);
//           return selectedDateObj >= from && selectedDateObj <= to;
//         })();

//       if (isUnavailable) return false;

//       // Validate by active tab
//       const cabFor = car.cab_available_for;
//       if (activeTab === "shared") {
//         return cabFor === "Shared-cab" || cabFor === "Both";
//       }
//       if (activeTab === "full") {
//         const isAssigned = tripdata.some(
//           (trip) => trip.vehicleId === car._id && trip.route === current_route._id
//         );
//         return (cabFor === "Full-Cab" || cabFor === "Both") && !isAssigned;
//       }

//       return false;
//     })
//     .flatMap((car) =>
//       (car.selected_schedules || []).map((schedule) => ({
//         ...car,
//         schedule_time: schedule.start,
//         schedule_id: schedule._id,
//       }))
//     );
// }, [all_vehicle, current_route, activeTab, retrievedData, tripdata, selectedDate]);





//   // Sort vehicles
//   const sortedVehicles = useMemo(() => {
//     const items = [...filteredVehicles];
//     if (!sortConfig.key) return items;
//     items.sort((a, b) => {
//       if (sortConfig.key === "price") {
//         const aP = getprice(a), bP = getprice(b);
//         return sortConfig.direction === "ascending" ? aP - bP : bP - aP;
//       }
//       if (sortConfig.key === "seats") {
//         const aS = a.seats.length, bS = b.seats.length;
//         return sortConfig.direction === "ascending" ? aS - bS : bS - aS;
//       }
//       if (sortConfig.key === "time") {
//         const tA = new Date(`1970-01-01T${a.time}`),
//           tB = new Date(`1970-01-01T${b.time}`);
//         return sortConfig.direction === "ascending" ? tA - tB : tB - tA;
//       }
//       return 0;
//     });
//     return items;
//   }, [filteredVehicles, sortConfig, getprice]);

//   const requestSort = (key) => {
//     const direction =
//       sortConfig.key === key && sortConfig.direction === "ascending"
//         ? "descending"
//         : "ascending";
//     setSortConfig({ key, direction });
//   };

//   const getSortIndicator = (key) =>
//     sortConfig.key !== key ? "⇵" : sortConfig.direction === "ascending" ? "▲" : "▼";

//   const convertTime = (kms) => {
//     if (!kms) return "0 hours";
//     const totalHours = (kms * 0.75) / 60;
//     const h = Math.floor(totalHours),
//       m = Math.round((totalHours - h) * 60);
//     return m === 0 ? `${h} ${h === 1 ? "hr" : "hrs"}` : `${h} ${h === 1 ? "hr" : "hrs"} ${m} min`;
//   };

//   const convertDateFormat = (d) => {
//     const dt = new Date(d);
//     return `${String(dt.getDate()).padStart(2, "0")}/${String(
//       dt.getMonth() + 1
//     ).padStart(2, "0")}/${dt.getFullYear()}`;
//   };

//   return (
//     <div className="flex flex-col lg:flex-row gap-4 px-0 lg:px-16 py-6 mt-28 mb-[5rem] font-lato">
//       <div className="w-full lg:w-3/4 bg-white bg-opacity-80 backdrop-blur-lg shadow-lg p-6 rounded-lg order-2 lg:order-1">
//         <div className="flex flex-wrap justify-center gap-4 mb-6">
//           <button
//             onClick={() => setActiveTab("shared")}
//             className={`px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium transition-all duration-300 shadow-md text-sm sm:text-base ${activeTab === "shared"
//               ? "bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-lg transform scale-105"
//               : "bg-gray-300 text-gray-700 hover:bg-gradient-to-r hover:from-gray-400 hover:to-gray-500 hover:text-white"
//               }`}>
//             Shared Cabs
//           </button>
//           <button
//             onClick={() => setActiveTab("full")}
//             className={`px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium transition-all duration-300 shadow-md text-sm sm:text-base ${activeTab === "full"
//               ? "bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-lg transform scale-105"
//               : "bg-gray-300 text-gray-700 hover:bg-gradient-to-r hover:from-gray-400 hover:to-gray-500 hover:text-white"
//               }`}>
//             Reserve Cabs
//           </button>
//         </div>
//         <div className="w-full flex flex-wrap justify-between bg-gray-100 shadow-md rounded-md p-3 text-center">
//           {[
//             { key: "seats", label: "Seats" },
//             { key: "price", label: "Fare" },
//             { key: "time", label: "Departure" },
//           ].map((header) => (
//             <div
//               key={header.key}
//               onClick={() => requestSort(header.key)}
//               className="flex-1 text-gray-700 font-semibold uppercase text-xs sm:text-sm cursor-pointer flex justify-center items-center hover:text-indigo-600 transition-all">
//               {header.label}
//               <span className="ml-1">{getSortIndicator(header.key)}</span>
//             </div>
//           ))}
//         </div>
//         {sortedVehicles.length ? (
//           sortedVehicles.map((car) => (
//             <div
//             key={`${car._id}`}
//               className="bg-white bg-opacity-90 backdrop-blur-md rounded-lg shadow-lg p-5 my-4 flex flex-col md:flex-row gap-6 border border-gray-200 hover:shadow-xl transition-all">
//               <img
//                 src={car.picture_of_the_vehicle}
//                 alt={car.brand_name}
//                 className="w-full md:w-1/3 h-48 object-cover rounded-lg shadow-md"
//               />
//               <div className="flex flex-col md:flex-row justify-between w-full">
//                 <div className="flex-grow text-center md:text-left">
//                   <h3 className="text-lg sm:text-xl font-bold text-gray-800">
//                     {car.brand_name}
//                   </h3>
//                   <p className="text-gray-600 text-sm sm:text-base">
//                     {car.seats.length} Seater
//                   </p>
//                   <ul className="text-gray-500 text-xs sm:text-sm mt-2">
//                     {car.features?.map((feature, i) => (
//                       <li key={i}>• {feature}</li>
//                     ))}
//                   </ul>
//                 </div>
//                 <div className="flex flex-col items-center justify-center text-center w-full md:w-1/3">
//                   <h1 className="text-md sm:text-lg font-semibold text-indigo-600">
//                     {convertDateFormat(retrievedData.date)}
//                   </h1>
//                   <h4 className="text-gray-500 text-xs sm:text-sm">{car.time}</h4>
//                   <p className="bg-blue-200 text-blue-600 px-2 sm:px-3 py-1 mt-3 rounded-full font-semibold text-xs sm:text-sm">
//                     Duration: {convertTime(current_route?.no_of_kms)}
//                   </p>
//                 </div>
//                 <div className="flex flex-col items-center md:items-end justify-between text-center md:text-right mt-4 md:mt-0">
//                   <p className="text-xl sm:text-2xl font-bold text-green-500">
//                     ₹{activeTab === "shared" ? Math.round(getprice(car)) : Math.round(getprice_for_fullcabs(car))}/-
//                   </p>
//                   <Link to={activeTab === "shared" ? `/Seats/${car._id}` : `/fullcabbook/${car._id}`}>
//                     <button className="mt-4 bg-gradient-to-r from-blue-400 to-blue-500 text-white py-2 px-4 sm:px-5 rounded-md shadow-lg hover:from-green-500 hover:to-green-700 transition-all">
//                       {activeTab === "shared" ? "Select Seat" : "Book Full Cab"}
//                     </button>
//                   </Link>
//                 </div>
//               </div>
//             </div>
//           ))
//         ) : (
//           <div className="text-center py-8">
//             <p className="text-gray-600 text-lg font-medium">
//               No {activeTab === "shared" ? "shared" : "full"} vehicles available on this route
//             </p>
//             <p className="text-gray-500 text-sm mt-2">
//               Please try different filters or check back later
//             </p>
//           </div>
//         )}
//       </div>
//       <div className="w-full lg:w-1/4 rounded-lg p-4 order-1 lg:order-2">
//         <TripDetailsCard />
//       </div>
//     </div>
//   );
// };

// export default CarList;

import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import TripDetailsCard from "./TripDetailsCard";
import { fetchAllvehicle, vehicleSelector } from "../api/vehicles";
import { useDispatch, useSelector } from "react-redux";
import { fetchoneroute_details, routeSelector } from "../api/route";
import { fetchpricingmodal, pricingSelector } from "../api/pricesetting";
import axios from "axios";
import { config, KeyUri } from "../key";
//import { Search } from "lucide-react";
/*---------------------------------------------------------------------------------------------------------*/
const CarList = () => {
  // Memoize retrievedData so it doesn't change on every render
  const [retrievedData] = useState(() =>
    JSON.parse(localStorage.getItem("Selected Data"))
  );
  const { all_vehicle } = useSelector(vehicleSelector);
  const { current_route } = useSelector(routeSelector);
  const { currentPricing } = useSelector(pricingSelector);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [tripdata, set_trip_data] = useState([]);
  const [ride_date, set_ride_date] = useState();
  //const [activeTab, setActiveTab] = useState("shared");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "ascending" });
  const [pricing_obj, setPricing_obj] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

   // For full cab, keep a record of time inputs per vehicle by _id
  const [fullCabTimes, setFullCabTimes] = useState({});
  /* const [activeTab, setActiveTab] = useState(() => {
  if (currentPricing?.[0]?.shared_cab_enabled) {
    return "shared";
  } else if (currentPricing?.[0]?.reserved_cab_enabled) {
    return "full";
  } else {
    return "shared"; // fallback, could show a "no cabs available" message
  }
}); */
 //console.log("current pricing -->", currentPricing)

 // *** MODIFIED *** Read tab pref from localStorage
  const savedTab = localStorage.getItem("lastActiveTab");

  // *** MODIFIED *** Determine if tabs are enabled from pricing
  const sharedEnabled = useMemo(() => currentPricing?.[0]?.shared_cab_enabled === true, [currentPricing]);
  const reservedEnabled = useMemo(() => currentPricing?.[0]?.reserved_cab_enabled === true, [currentPricing]);

  // *** MODIFIED *** Initialize activeTab from savedTab if valid, else fallback to enabled tab
  const [activeTab, setActiveTab] = useState(() => {
    if (savedTab === "shared" && sharedEnabled) return "shared";
    if (savedTab === "full" && reservedEnabled) return "full";
    if (sharedEnabled) return "shared";
    if (reservedEnabled) return "full";
    return "shared";
  });

  // *** MODIFIED *** Auto switch activeTab if current tab disabled
  useEffect(() => {
    if (activeTab === "shared" && !sharedEnabled && reservedEnabled) {
      setActiveTab("full");
    } else if (activeTab === "full" && !reservedEnabled && sharedEnabled) {
      setActiveTab("shared");
    }
  }, [activeTab, sharedEnabled, reservedEnabled]);

  // *** MODIFIED *** Save activeTab to localStorage on change
  useEffect(() => {
    localStorage.setItem("lastActiveTab", activeTab);
  }, [activeTab]);

/*const sharedEnabled = useMemo(() => {
  return currentPricing?.[0]?.shared_cab_enabled === true;
}, [currentPricing]);

const reservedEnabled = useMemo(() => {
  return currentPricing?.[0]?.reserved_cab_enabled === true;
}, [currentPricing]);*/



  // Run once on mount
  useEffect(() => {
    if (!retrievedData) return;
    dispatch(fetchAllvehicle());
    dispatch(fetchoneroute_details(retrievedData));
    dispatch(fetchpricingmodal());
    const formattedDate = new Date(retrievedData?.date).toISOString();
    set_ride_date(formattedDate);
  }, [dispatch, retrievedData]);

  // Fetch trip data when ride_date changes
  useEffect(() => {
    if (!ride_date) return;
    const fetchTrip = async () => {
      
      try {
        const response = await axios.post(
          `${KeyUri.BACKEND_URI}/get-full-cabs`,
          { rideDate: ride_date }, config
        );
    
        set_trip_data(response.data.details || []);
      } catch (error) {
        console.error("Error fetching trip:", error.response?.data || error.message);
      }
    };
    fetchTrip();
  }, [ride_date]);

  // Update pricing object when currentPricing changes
  useEffect(() => {
    setPricing_obj(currentPricing?.[0] || {});
  }, [currentPricing]);

  // Memoize getprice to avoid recreation
  /*const getprice = useCallback(
    (car) => {
      if (!car || !pricing_obj || !current_route) return 0;
      if (pricing_obj.pricing_model === "Driver Fixed") {
        const perSeat =
          Number(car.price_per_trip?.$numberDecimal) / (car.capacity - 1);
        return perSeat + perSeat * (pricing_obj.platform_price / 100);
      }
      if (pricing_obj.pricing_model === "Admin Fixed") {
        const key =
          car.category === "Economy"
            ? "price_for_economy"
            : car.category === "Luxury"
              ? "price_for_luxary"
              : "price_for_premium";
        const base = Number(current_route[key]?.$numberDecimal) || 0;
        return base + base * (pricing_obj.platform_price / 100);
      }
      return 0;
    },
    [pricing_obj, current_route]
  );*/
const getprice = useCallback(
  (car) => {
    if (!car || !pricing_obj || !current_route) return 0;

    if (pricing_obj.pricing_model === "Driver Fixed") {
      // Find route pricing from selected_schedules, accounting for populated or string route IDs
      const routePricing = car.selected_schedules?.find((r) => {
        const routeId = typeof r.route === "string" ? r.route : r.route?._id;
        return routeId === current_route._id;
      });

      if (!routePricing) {
       
        return 0;
      }

      // Safely extract price_per_Trip, supporting Decimal128 or number formats
      const perTripPrice = Number(
        routePricing.price_per_Trip?.$numberDecimal || routePricing.price_per_Trip || 0
      );

      // Calculate per seat price by dividing by total seats -1 (assuming one seat is driver)
      const perSeatPrice = perTripPrice / (car.capacity - 1);

      // Add platform fees (percentage)
      const finalPrice = perSeatPrice + perSeatPrice * (pricing_obj.platform_price / 100);

      return finalPrice;
    }

    if (pricing_obj.pricing_model === "Admin Fixed") {
      const key =
        car.category === "Economy"
          ? "price_for_economy"
          : car.category === "Luxury"
          ? "price_for_luxary"
          : "price_for_premium";

      const base = Number(current_route[key]?.$numberDecimal) || 0;

      const finalPrice = base + base * (pricing_obj.platform_price / 100);
      return finalPrice;
    }

    return 0;
  },
  [pricing_obj, current_route]
);



  // pricing for full cabs function 
  const getprice_for_fullcabs = useCallback(
    (car) => {
      if (!car || !pricing_obj || !current_route) return 0;

      if (pricing_obj?.pricing_model_for_fullcabs === "Driver Fixed") {
        const perTrip = (Number(car?.price_per_km?.$numberDecimal) * current_route?.no_of_kms);
        return perTrip * (1 + pricing_obj?.platform_price_for_full_cabs / 100);
      }

      if (pricing_obj?.pricing_model_for_fullcabs === "Admin Fixed") {
        const key =
          car.category === "Economy"
            ? "full_cab_price_for_economy"
            : car.category === "Luxury"
              ? "full_cab_price_for_luxary"
              : "full_cab_price_for_premium";
        const base =
          Number(current_route[key]?.$numberDecimal) * (1) || 0;
        return base * (1 + pricing_obj.platform_price_for_full_cabs / 100);
      }

      return 0;
    },
    [pricing_obj, current_route]
  ); 


  /*const getprice_for_fullcabs = useCallback(
  (car) => {
    if (!car || !pricing_obj || !current_route) return 0;

    if (pricing_obj?.pricing_model_for_fullcabs === "Driver Fixed") {
      // Find route pricing (handle string or object route ID)
      const routePricing = car.selected_schedules?.find((r) => {
        const routeId = typeof r.route === "string" ? r.route : r.route?._id;
        return routeId === current_route._id;
      });

      let basePrice = 0;
      if (routePricing) {
        // Use route-based price_per_KM * no_of_kms if available and greater than zero
        const pricePerKm =
          Number(routePricing.price_per_KM?.$numberDecimal || routePricing.price_per_KM) || 0;

        if (pricePerKm > 0 && current_route?.no_of_kms) {
          basePrice = pricePerKm * current_route.no_of_kms;
        } else {
          // Fallback to route-based price_per_Trip if price_per_KM not valid
          basePrice =
            Number(routePricing.price_per_Trip?.$numberDecimal || routePricing.price_per_Trip) || 0;
        }

        // Include extra charges if any
        if (routePricing.extra_charges) {
          basePrice += Number(routePricing.extra_charges);
        }
      }

      // Apply platform fee
      return basePrice * (1 + (pricing_obj?.platform_price_for_full_cabs || 0) / 100);
    }

    if (pricing_obj?.pricing_model_for_fullcabs === "Admin Fixed") {
      const key =
        car.category === "Economy"
          ? "full_cab_price_for_economy"
          : car.category === "Luxury"
          ? "full_cab_price_for_luxary"
          : "full_cab_price_for_premium";

      let base = Number(current_route[key]?.$numberDecimal || current_route[key]) || 0;

      // Include any extra route-level charges
      if (current_route?.[`${key}_extra_charges`]) {
        base += Number(current_route[`${key}_extra_charges`]);
      }

      // Apply platform fee
      return base * (1 + (pricing_obj.platform_price_for_full_cabs || 0) / 100);
    }

    return 0;
  },
  [pricing_obj, current_route]
);*/


  const selectedDate = retrievedData?.date;

  // Filter vehicles based on active tab and expand by schedule
/* const filteredVehicles = useMemo(() => {
    if (!all_vehicle || !current_route || !selectedDate) return [];

    const selectedDateObj = new Date(selectedDate);

    // Base vehicle filtering
    const baseFiltered = all_vehicle.filter(car => {
      // Check if vehicle is unavailable
      const isUnavailable = () => {
        if (car.not_available?.from) {
          const fromDate = new Date(car.not_available.from);
          const toDate = car.not_available.to ? new Date(car.not_available.to) : null;
         // return selectedDateObj >= fromDate && selectedDateObj <= toDate;
         
         if (!toDate) {
    return selectedDateObj >= fromDate;
  }

  // Case 2: Unavailable between two dates
  return selectedDateObj >= fromDate && selectedDateObj <= toDate;
        }
        return false;
      };
       const unavailable = isUnavailable();

    // Debug log
    console.log(
      "Car:", car.brand_name,
      "| From:", car.not_available?.from,
      "| To:", car.not_available?.to,
      "| Unavailable:", unavailable
    );

      if (isUnavailable()) return false;

      const sameRoute = Array.isArray(car?.route_id) && (
        car.route_id.includes(current_route?._id) ||
        car.route_id.some(r => r?._id === current_route?._id)
      );
      const categoryMatch = car.category === retrievedData?.seats;

      if (activeTab === "shared") {
        const sharedCab = car?.cab_available_for === 'Shared-cab' || car?.cab_available_for === 'Both';
        return sameRoute && categoryMatch && sharedCab;
      } else {
        const fullCab = car?.cab_available_for === 'Full-Cab' || car?.cab_available_for === 'Both';
        const assigned = tripdata.some(
          trip => trip.vehicleId === car._id && trip.route === current_route._id
        );
        return sameRoute && !assigned && fullCab && categoryMatch;
      }
      
    });
    

    // Expand vehicles by their schedules
    return baseFiltered.flatMap(car => {
      if (
        Array.isArray(car.selected_schedules) &&
        car.selected_schedules.length > 0
      ) {
        return car.selected_schedules
          .filter(routeSchedule => {
            const route = routeSchedule?.route;
            // Handle both string and populated object
            return (
              route === current_route._id ||
              route?._id === current_route._id
            );
          })
          .flatMap(routeSchedule => {
            const routeId = routeSchedule?.route?._id || routeSchedule?.route;
    
            // Case 1: Populated schedules (objects with start time)
            if (
              Array.isArray(routeSchedule.schedules) &&
              typeof routeSchedule.schedules[0] === 'object'
            ) {
              return routeSchedule.schedules.map(schedule => ({
                ...car,
                route_id: routeId,
                schedule_time: schedule.start,
                schedule_id: schedule._id
              }));
            }
    
            // Case 2: Unpopulated schedules (IDs only)
            return routeSchedule.schedules.map(scheduleId => ({
              ...car,
              route_id: routeId,
              schedule_time: null, // No start time since it's unpopulated
              schedule_id: scheduleId
            }));
          });
      }
    
      // Fallback: No selected_schedules
      return [{
        ...car,
        schedule_time: car.time,
        schedule_id: null
      }];
    });
    
  }, [all_vehicle, current_route, activeTab, retrievedData, tripdata, selectedDate]);
*/
const filteredVehicles = useMemo(() => {
   
  if (!all_vehicle || !current_route || !selectedDate) return [];

  const selectedDateObj = new Date(selectedDate);

  
//  const today = new Date();
  //const cutoffDate = new Date();
  //cutoffDate.setDate(today.getDate() + 10);

   //if (selectedDateObj > cutoffDate) {
   // console.log("Selected date is beyond 10 days → no vehicles shown");
   // return [];
  //}
  
  // Base vehicle filtering
  const baseFiltered = all_vehicle.filter(car => {
    // Check date-based unavailability
    const isDateUnavailable = () => {
      if (!car.not_available?.from) return false;

      const fromDate = new Date(car.not_available.from);
      const toDate = car.not_available.to ? new Date(car.not_available.to) : null;

      // Handle invalid date ranges
      if (toDate && fromDate > toDate) {
        console.warn(`⚠ Invalid not_available range for car: ${car.brand_name}`, fromDate, toDate);
        return false;
      }

      // Indefinite unavailability (no "to" date)
      if (!toDate) return selectedDateObj >= fromDate;

      // Unavailable between two dates
      return selectedDateObj >= fromDate && selectedDateObj <= toDate;
    };

    const unavailableByDate = isDateUnavailable();
    const unavailableByToggle = !!car.isUnavailable; // Boolean toggle

    // Debug
   /* console.log(
      "Car:", car.brand_name,
      "| From:", car.not_available?.from,
      "| To:", car.not_available?.to,
      "| Toggle Unavailable:", unavailableByToggle,
      "| Date Unavailable:", unavailableByDate
    );*/

    
    //if (unavailableByToggle || unavailableByDate) return false;

    // Priority-based filtering
if (unavailableByToggle) return false; // toggle ON = unavailable
if (unavailableByDate) return false;   // only checked if toggle is OFF

//const vehicle123wer = all_vehicle.find(car => car.reg_no === "wer123");
//console.log("Vehicle 'wer123' route_id:", vehicle123wer?.route_id);


    // Route match
  const sameRoute = Array.isArray(car?.route_id) && car.route_id.some(r => {
  // r can be object with _id or primitive, so extract _id if object
  const routeId = (typeof r === "object" && r !== null && "_id" in r) ? r._id.toString() : r.toString();
  return routeId === current_route._id.toString();
});


    // Category match
    const categoryMatch = car.category === retrievedData?.seats;

    if (activeTab === "shared") {
      const sharedCab = car?.cab_available_for === 'Shared-cab' || car?.cab_available_for === 'Both';
      return sameRoute && categoryMatch && sharedCab;
    } 
   /*if (activeTab === "shared") {
  const sharedCab = car?.cab_available_for === 'Shared-cab' || car?.cab_available_for === 'Both';
  // Hide vehicle from shared cab if full cab already booked on same date+route
  const isFullyBooked = tripdata.some(trip => 
    trip.vehicleId === car._id &&
    trip.route === current_route._id &&
    new Date(trip.rideDate).toDateString() === new Date(selectedDate).toDateString()
  );
  return sameRoute && categoryMatch && sharedCab && !isFullyBooked;
}*/

    else {
      const fullCab = car?.cab_available_for === 'Full-Cab' || car?.cab_available_for === 'Both';
      const assigned = tripdata.some(
        trip => trip.vehicleId === car._id && trip.route === current_route._id
      );
      return sameRoute && !assigned && fullCab && categoryMatch;
    }
  });
    //console.log(`Vehicles matching route ${current_route._id}:`, baseFiltered.map(v => ({ id: v._id, reg_no: v.reg_no })));

  // Expand vehicles by their schedules

return baseFiltered.map(car => {
  const routeSchedules = car.selected_schedules?.filter(routeSchedule => {
  const route = routeSchedule?.route;
  const routeId = (typeof route === "object" && route !== null && "_id" in route)
    ? route._id.toString()
    : route.toString();
  return routeId === current_route._id.toString();
}) || [];

  // collect schedules
  const schedules = routeSchedules.flatMap(routeSchedule =>
    Array.isArray(routeSchedule.schedules)
      ? routeSchedule.schedules.map(sch =>
          typeof sch === "object" ? { id: sch._id, time: sch.start } : { id: sch, time: null }
        )
      : []
  );

  return { ...car, schedules };
});




   // return [{
   //   ...car,
   //   schedule_time: car.time,
   //   schedule_id: null
   // }];
  //});

}, [all_vehicle, current_route, activeTab, retrievedData, tripdata, selectedDate]);

  // Sort vehicles
  const sortedVehicles = useMemo(() => {
    const items = [...filteredVehicles];
    if (!sortConfig.key) return items;

    items.sort((a, b) => {
      if (sortConfig.key === "price") {
        const aP = activeTab === "shared" ? getprice(a) : getprice_for_fullcabs(a);
        const bP = activeTab === "shared" ? getprice(b) : getprice_for_fullcabs(b);
        return sortConfig.direction === "ascending" ? aP - bP : bP - aP;
      }
      if (sortConfig.key === "seats") {
        const aS = a.seats.length, bS = b.seats.length;
        return sortConfig.direction === "ascending" ? aS - bS : bS - aS;
      }
      if (sortConfig.key === "time") {
        const tA = new Date(`1970-01-01T${a.schedule_time}`);
        const tB = new Date(`1970-01-01T${b.schedule_time}`);
        return sortConfig.direction === "ascending" ? tA - tB : tB - tA;
      }
      return 0;
    });
    return items;
  }, [filteredVehicles, sortConfig, getprice, getprice_for_fullcabs, activeTab]);

  

  const requestSort = (key) => {
    const direction =
      sortConfig.key === key && sortConfig.direction === "ascending"
        ? "descending"
        : "ascending";
    setSortConfig({ key, direction });
  };

  const getSortIndicator = (key) =>
    sortConfig.key !== key ? "⇵" : sortConfig.direction === "ascending" ? "▲" : "▼";

  const convertTime = (kms) => {
    if (!kms) return "0 hours";
    const totalHours = (kms * 0.75) / 60;
    const h = Math.floor(totalHours),
      m = Math.round((totalHours - h) * 60);
    return m === 0 ? `${h} ${h === 1 ? "hr" : "hrs"}` : `${h} ${h === 1 ? "hr" : "hrs"} ${m} min`;
  };

  const convertDateFormat = (d) => {
    const dt = new Date(d);
    return `${String(dt.getDate()).padStart(2, "0")}/${String(
      dt.getMonth() + 1
    ).padStart(2, "0")}/${dt.getFullYear()}`;
  };
  const formatTime = (timeStr) => {
  if (!timeStr) return "";
  try {
    const [hours, minutes] = timeStr.split(":").map(Number);
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  } catch {
    return timeStr;
  }
};

const searchedVehicles = useMemo(() => {
  if (!searchTerm) return sortedVehicles;
  return sortedVehicles.filter((car) =>
    `${car.brand_name} ${car.model_name} ${car.reg_no}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );
}, [sortedVehicles, searchTerm]);

  return (
    <div className="flex flex-col lg:flex-row gap-4 px-0 lg:px-16 py-6 mt-48 md:mt-32 mb-[5rem] font-lato">
      <div className="w-full lg:w-3/4 bg-white bg-opacity-80 backdrop-blur-lg shadow-lg p-6 rounded-lg order-2 lg:order-1">
        <div className="flex flex-wrap justify-center gap-4 mb-6 -mt-4">
          <button
              onClick={() => setActiveTab("shared")}
            className={`px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium transition-all duration-300 shadow-md text-sm sm:text-base ${activeTab === "shared"
              ? "bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-lg transform scale-105"
              : "bg-gray-300 text-gray-700 hover:bg-gradient-to-r hover:from-gray-400 hover:to-gray-500 hover:text-white"
              }`}>
            Shared Cabs
          </button>
          <button
            onClick={() => setActiveTab("full")}
            className={`px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium transition-all duration-300 shadow-md text-sm sm:text-base ${activeTab === "full"
              ? "bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-lg transform scale-105"
              : "bg-gray-300 text-gray-700 hover:bg-gradient-to-r hover:from-gray-400 hover:to-gray-500 hover:text-white"
              }`}>
            Reserve Cabs
          </button>
        </div>
          {/* 🔍 Search bar */}
        <div className="relative w-full sm:w-1/2 md:w-1/3 mb-4">
  <input
    type="text"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    placeholder="Search by brand, model, or reg no"
    className="w-full px-4 py-2 border rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-400"
  />
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="absolute right-3 top-2.5 h-5 w-5 text-gray-500"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1110.5 3a7.5 7.5 0 016.15 13.65z"
    />
  </svg>
</div>
        <div className="w-full flex flex-wrap justify-between bg-gray-100 shadow-md rounded-md p-3 text-center">
          {[
            { key: "seats", label: "Seats" },
            { key: "price", label: "Fare" },
            { key: "time", label: "Departure" },
          ].map((header) => (
            <div
              key={header.key}
              onClick={() => requestSort(header.key)}
              className="flex-1 text-gray-700 font-semibold uppercase text-xs sm:text-sm cursor-pointer flex justify-center items-center hover:text-indigo-600 transition-all">
              {header.label}
              <span className="ml-1">{getSortIndicator(header.key)}</span>
            </div>
          ))}
        </div>
          {(activeTab === "shared" && !sharedEnabled) || (activeTab === "full" && !reservedEnabled) ? (
          <div className="text-center py-8">
            <p className="text-gray-600 text-lg font-medium">
              {activeTab === "shared" ? "Shared Cabs" : "Reserved Cabs"} are temporarily unavailable
            </p>
            <p className="text-gray-500 text-sm mt-2">
              Please check back later or try another option
            </p>
          </div>
        ) : searchedVehicles.length ? (
          searchedVehicles.map((car) => (
            <div
              key={`${car._id}-${car.schedule_id || "default"}`}
              className="bg-white bg-opacity-90 backdrop-blur-md rounded-lg shadow-lg p-5 my-4 flex flex-col md:flex-row gap-6 border border-gray-200 hover:shadow-xl transition-all">
              <img
                src={car.picture_of_the_vehicle}
                alt={`${car?.brand_name ?? ''} ${car?.model_name ?? ''}`}

                className="w-full md:w-1/3 h-48 object-cover rounded-lg shadow-md"
              />
              <div className="flex flex-col md:flex-row justify-between w-full">
                <div className="flex-grow text-center md:text-left">
                  
                  <h3 className="text-lg sm:text-xl font-bold text-gray-800">
                    {car.brand_name + ' ' + car.model_name}

                  </h3>
                   <h5 className="text-sm sm:text-md font-bold text-gray-600">
                    Register No: {car.reg_no}

                  </h5>
                  <p className="text-gray-600 text-sm sm:text-base">
                    {car.seats.length} Seater
                  </p>
                  <ul className="text-gray-500 text-xs sm:text-sm mt-2">
                    {car.features?.map((feature, i) => (
                      <li key={i}>• {feature}</li>
                    ))}
                  </ul>
                </div>
                <div className="flex flex-col items-center justify-center text-center w-full md:w-1/3">
                  <h1 className="text-md sm:text-lg font-semibold text-indigo-600">
                    {convertDateFormat(retrievedData.date)}
                  </h1>
     {/*<h4 className="text-gray-500 text-xs sm:text-sm">
  {car.schedule_time
    ? `Departure: ${formatTime(car.schedule_time)}`
    : "No schedule available"}
</h4> */}
  {/* Dropdown for schedules */}
      {/* SCHEDULE UI FOR SHARED: Dropdown; FULL: Time Input */}
                  {activeTab === "shared" ? (
                    car.schedules.length > 0 ? (
                      <select
                        className="block border border-gray-300 bg-white rounded-md shadow-sm py-2 px-3 mt-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-150 ease-in-out"
                        onChange={e => car.selectedSchedule = e.target.value}
                        defaultValue=""
                      >
                        <option value="" disabled>Select Schedule</option>
                        {car.schedules.map(sch => (
                          <option key={sch.id} value={sch.id}>
                            {sch.time ? formatTime(sch.time) : "No time available"}
                          </option>
                        ))}
                      </select>
                    ) : <p className="text-gray-500 text-xs">No schedules available</p>
                  ) : (
                    <>
                    <label htmlFor={`pickup-time-${car._id}`} className="block text-gray-700 mt-1">
  Enter/Select Pickup Time from below
</label>
                    <input
                    id={`pickup-time-${car._id}`}
                      type="time"
                      className="block border border-gray-300 bg-white rounded-md shadow-sm py-2 px-3 mt-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-150 ease-in-out"
                      value={fullCabTimes[car._id] || ""}
                      onChange={e =>
                        setFullCabTimes(times => ({
                          ...times,
                          [car._id]: e.target.value,
                        }))
                      }
                      placeholder="Enter Pickup Time"
                    />
                    </>
                  )}

                  <p className="bg-blue-200 text-blue-600 px-2 sm:px-3 py-1 mt-3 rounded-full font-semibold text-xs sm:text-sm">
                    Duration: {current_route?.duration || "Not specified"}
                  </p>
                </div>
                <div className="flex flex-col items-center md:items-end justify-between text-center md:text-right mt-4 md:mt-0">
                  <p className="text-xl sm:text-2xl font-bold text-green-500">
                    ₹{activeTab === "shared" ? Math.round(getprice(car)) : Math.round(getprice_for_fullcabs(car))}/-
                  </p>
                  <button
  onClick={() => {
    try {
      const existingBooking = JSON.parse(localStorage.getItem("Selected Data"));
      let updatedBooking = { ...existingBooking };

      if (activeTab === "shared") {
        // Handle shared cab booking like before
        const scheduleId = car.selectedSchedule;
        if (!scheduleId) {
          alert("Please select a schedule before booking");
          return;
        }
        const selectedSchedule = car.schedules.find(s => s.id === scheduleId);
        let time = selectedSchedule?.time;
        if (!time) throw new Error("Schedule time is missing");
        if (time.length === 5) time += ":00";
        const rawDate = existingBooking.date?.split("T")[0];
        const fullDateTime = `${rawDate}T${time}`;
        const fullDateObj = new Date(fullDateTime);
        if (isNaN(fullDateObj.getTime())) {
          alert("Invalid date or time format");
          return;
        }
        updatedBooking = {
          ...existingBooking,
          date: fullDateObj.toISOString(),
          schedule_id: scheduleId,
        };
      } else {
        // Handle full cab booking using the time input
        const pickupTime = fullCabTimes[car._id];
        if (!pickupTime) {
          alert("Please enter a pickup time before booking");
          return;
        }
        let time = pickupTime;
        if (time.length === 5) time += ":00";
        const rawDate = existingBooking.date?.split("T")[0];
        const fullDateTime = `${rawDate}T${time}`;
        const fullDateObj = new Date(fullDateTime);
        if (isNaN(fullDateObj.getTime())) {
          alert("Invalid date or time format");
          return;
        }
        updatedBooking = {
          ...existingBooking,
          date: fullDateObj.toISOString(),
          schedule_id: null,
          pickup_time: time // optional: for backend clarity
        };
      }

      localStorage.setItem("Selected Data", JSON.stringify(updatedBooking));
      const path = activeTab === "shared" ? `/Seats/${car._id}` : `/fullcabbook/${car._id}`;
      navigate(path);
    } catch (err) {
      console.error("Booking error:", err);
      alert("Something went wrong while booking. Please try again.");
    }
  }}
  className="mt-4 bg-gradient-to-r from-blue-400 to-blue-500 text-white py-2 px-4 sm:px-5 rounded-md shadow-lg hover:from-green-500 hover:to-green-700 transition-all"
>
  {activeTab === "shared" ? "Select Seat" : "Book Full Cab"}
</button>


                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-8">
            <p className="text-gray-600 text-lg font-medium">
              No {activeTab === "shared" ? "shared" : "full"} vehicles available on this route
            </p>
            <p className="text-gray-500 text-sm mt-2">
              Please try different filters or check back later
            </p>
          </div>
        )}
      </div>
      <div className="w-full lg:w-1/4 rounded-lg p-4 order-1 lg:order-2">
        <TripDetailsCard />
      </div>
    </div>
  );
};

export default CarList; 


{/*-------------------------------------------------------------------------------------------------------------------*/}
/*

const CarList = () => {
  // Memoize retrievedData so it doesn't change on every render
  const [retrievedData] = useState(() =>
    JSON.parse(localStorage.getItem("Selected Data"))
  );
  const { all_vehicle } = useSelector(vehicleSelector);
  const { current_route } = useSelector(routeSelector);
  const { currentPricing } = useSelector(pricingSelector);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [tripdata, set_trip_data] = useState([]);
  const [ride_date, set_ride_date] = useState();
  //const [activeTab, setActiveTab] = useState("shared");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "ascending" });
  const [pricing_obj, setPricing_obj] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  const [activeTab, setActiveTab] = useState(() => {
  if (currentPricing?.[0]?.shared_cab_enabled) {
    return "shared";
  } else if (currentPricing?.[0]?.reserved_cab_enabled) {
    return "full";
  } else {
    return "shared"; // fallback, could show a "no cabs available" message
  }
});


 console.log("current pricing -->", currentPricing)

const sharedEnabled = useMemo(() => {
  return currentPricing?.[0]?.shared_cab_enabled === true;
}, [currentPricing]);

const reservedEnabled = useMemo(() => {
  return currentPricing?.[0]?.reserved_cab_enabled === true;
}, [currentPricing]);



  // Run once on mount
  useEffect(() => {
    if (!retrievedData) return;
    dispatch(fetchAllvehicle());
    dispatch(fetchoneroute_details(retrievedData));
    dispatch(fetchpricingmodal());
    const formattedDate = new Date(retrievedData?.date).toISOString();
    set_ride_date(formattedDate);
  }, [dispatch, retrievedData]);

  // Fetch trip data when ride_date changes
  useEffect(() => {
    if (!ride_date) return;
    const fetchTrip = async () => {
      console.log("api trigerred----->")
      try {
        const response = await axios.post(`${KeyUri.BACKEND_URI}/get-full-cabs`,
          { rideDate: ride_date }, config
        );
        console.log("ride dateee",ride_date)
        set_trip_data(response.data.details || []);
      } catch (error) {
        console.error("Error fetching trip:", error.response?.data || error.message);
      }
    };
    fetchTrip();
  }, [ride_date]);

  // Update pricing object when currentPricing changes
  useEffect(() => {
    setPricing_obj(currentPricing?.[0] || {});
  }, [currentPricing]);

  // Memoize getprice to avoid recreation
  /*const getprice = useCallback(
    (car) => {
      if (!car || !pricing_obj || !current_route) return 0;
      if (pricing_obj.pricing_model === "Driver Fixed") {
        const perSeat =
          Number(car.price_per_trip?.$numberDecimal) / (car.capacity - 1);
        return perSeat + perSeat * (pricing_obj.platform_price / 100);
      }
      if (pricing_obj.pricing_model === "Admin Fixed") {
        const key =
          car.category === "Economy"
            ? "price_for_economy"
            : car.category === "Luxury"
              ? "price_for_luxary"
              : "price_for_premium";
        const base = Number(current_route[key]?.$numberDecimal) || 0;
        return base + base * (pricing_obj.platform_price / 100);
      }
      return 0;
    },
    [pricing_obj, current_route]
  );*
const getprice = useCallback(
  (car) => {
    if (!car || !pricing_obj || !current_route) return 0;

    if (pricing_obj.pricing_model === "Driver Fixed") {
      // Find route pricing from selected_schedules, accounting for populated or string route IDs
      const routePricing = car.selected_schedules?.find((r) => {
        const routeId = typeof r.route === "string" ? r.route : r.route?._id;
        return routeId === current_route._id;
      });

      if (!routePricing) {
        console.log(`No pricing found for route ${current_route._id} in vehicle ${car._id}`);
        return 0;
      }

      // Safely extract price_per_Trip, supporting Decimal128 or number formats
      const perTripPrice = Number(
        routePricing.price_per_Trip?.$numberDecimal || routePricing.price_per_Trip || 0
      );

      // Calculate per seat price by dividing by total seats -1 (assuming one seat is driver)
      const perSeatPrice = perTripPrice / (car.capacity - 1);

      // Add platform fees (percentage)
      const finalPrice = perSeatPrice + perSeatPrice * (pricing_obj.platform_price / 100);

      return finalPrice;
    }

    if (pricing_obj.pricing_model === "Admin Fixed") {
      const key =
        car.category === "Economy"
          ? "price_for_economy"
          : car.category === "Luxury"
          ? "price_for_luxary"
          : "price_for_premium";

      const base = Number(current_route[key]?.$numberDecimal) || 0;

      const finalPrice = base + base * (pricing_obj.platform_price / 100);
      return finalPrice;
    }

    return 0;
  },
  [pricing_obj, current_route]
);



  // pricing for full cabs function 
  const getprice_for_fullcabs = useCallback(
    (car) => {
      if (!car || !pricing_obj || !current_route) return 0;

      if (pricing_obj?.pricing_model_for_fullcabs === "Driver Fixed") {
        const perTrip = (Number(car?.price_per_km?.$numberDecimal) * current_route?.no_of_kms);
        return perTrip * (1 + pricing_obj?.platform_price_for_full_cabs / 100);
      }

      if (pricing_obj?.pricing_model_for_fullcabs === "Admin Fixed") {
        const key =
          car.category === "Economy"
            ? "full_cab_price_for_economy"
            : car.category === "Luxury"
              ? "full_cab_price_for_luxary"
              : "full_cab_price_for_premium";
        const base =
          Number(current_route[key]?.$numberDecimal) * (1) || 0;
        return base * (1 + pricing_obj.platform_price_for_full_cabs / 100);
      }

      return 0;
    },
    [pricing_obj, current_route]
  ); 


  /*const getprice_for_fullcabs = useCallback(
  (car) => {
    if (!car || !pricing_obj || !current_route) return 0;

    if (pricing_obj?.pricing_model_for_fullcabs === "Driver Fixed") {
      // Find route pricing (handle string or object route ID)
      const routePricing = car.selected_schedules?.find((r) => {
        const routeId = typeof r.route === "string" ? r.route : r.route?._id;
        return routeId === current_route._id;
      });

      let basePrice = 0;
      if (routePricing) {
        // Use route-based price_per_KM * no_of_kms if available and greater than zero
        const pricePerKm =
          Number(routePricing.price_per_KM?.$numberDecimal || routePricing.price_per_KM) || 0;

        if (pricePerKm > 0 && current_route?.no_of_kms) {
          basePrice = pricePerKm * current_route.no_of_kms;
        } else {
          // Fallback to route-based price_per_Trip if price_per_KM not valid
          basePrice =
            Number(routePricing.price_per_Trip?.$numberDecimal || routePricing.price_per_Trip) || 0;
        }

        // Include extra charges if any
        if (routePricing.extra_charges) {
          basePrice += Number(routePricing.extra_charges);
        }
      }

      // Apply platform fee
      return basePrice * (1 + (pricing_obj?.platform_price_for_full_cabs || 0) / 100);
    }

    if (pricing_obj?.pricing_model_for_fullcabs === "Admin Fixed") {
      const key =
        car.category === "Economy"
          ? "full_cab_price_for_economy"
          : car.category === "Luxury"
          ? "full_cab_price_for_luxary"
          : "full_cab_price_for_premium";

      let base = Number(current_route[key]?.$numberDecimal || current_route[key]) || 0;

      // Include any extra route-level charges
      if (current_route?.[${key}_extra_charges]) {
        base += Number(current_route[${key}_extra_charges]);
      }

      // Apply platform fee
      return base * (1 + (pricing_obj.platform_price_for_full_cabs || 0) / 100);
    }

    return 0;
  },
  [pricing_obj, current_route]
);*


  const selectedDate = retrievedData?.date;

  // Filter vehicles based on active tab and expand by schedule
/* const filteredVehicles = useMemo(() => {
    if (!all_vehicle || !current_route || !selectedDate) return [];

    const selectedDateObj = new Date(selectedDate);

    // Base vehicle filtering
    const baseFiltered = all_vehicle.filter(car => {
      // Check if vehicle is unavailable
      const isUnavailable = () => {
        if (car.not_available?.from) {
          const fromDate = new Date(car.not_available.from);
          const toDate = car.not_available.to ? new Date(car.not_available.to) : null;
         // return selectedDateObj >= fromDate && selectedDateObj <= toDate;
         
         if (!toDate) {
    return selectedDateObj >= fromDate;
  }

  // Case 2: Unavailable between two dates
  return selectedDateObj >= fromDate && selectedDateObj <= toDate;
        }
        return false;
      };
       const unavailable = isUnavailable();

    // Debug log
    console.log(
      "Car:", car.brand_name,
      "| From:", car.not_available?.from,
      "| To:", car.not_available?.to,
      "| Unavailable:", unavailable
    );

      if (isUnavailable()) return false;

      const sameRoute = Array.isArray(car?.route_id) && (
        car.route_id.includes(current_route?._id) ||
        car.route_id.some(r => r?._id === current_route?._id)
      );
      const categoryMatch = car.category === retrievedData?.seats;

      if (activeTab === "shared") {
        const sharedCab = car?.cab_available_for === 'Shared-cab' || car?.cab_available_for === 'Both';
        return sameRoute && categoryMatch && sharedCab;
      } else {
        const fullCab = car?.cab_available_for === 'Full-Cab' || car?.cab_available_for === 'Both';
        const assigned = tripdata.some(
          trip => trip.vehicleId === car._id && trip.route === current_route._id
        );
        return sameRoute && !assigned && fullCab && categoryMatch;
      }
      
    });
    

    // Expand vehicles by their schedules
    return baseFiltered.flatMap(car => {
      if (
        Array.isArray(car.selected_schedules) &&
        car.selected_schedules.length > 0
      ) {
        return car.selected_schedules
          .filter(routeSchedule => {
            const route = routeSchedule?.route;
            // Handle both string and populated object
            return (
              route === current_route._id ||
              route?._id === current_route._id
            );
          })
          .flatMap(routeSchedule => {
            const routeId = routeSchedule?.route?._id || routeSchedule?.route;
    
            // Case 1: Populated schedules (objects with start time)
            if (
              Array.isArray(routeSchedule.schedules) &&
              typeof routeSchedule.schedules[0] === 'object'
            ) {
              return routeSchedule.schedules.map(schedule => ({
                ...car,
                route_id: routeId,
                schedule_time: schedule.start,
                schedule_id: schedule._id
              }));
            }
    
            // Case 2: Unpopulated schedules (IDs only)
            return routeSchedule.schedules.map(scheduleId => ({
              ...car,
              route_id: routeId,
              schedule_time: null, // No start time since it's unpopulated
              schedule_id: scheduleId
            }));
          });
      }
    
      // Fallback: No selected_schedules
      return [{
        ...car,
        schedule_time: car.time,
        schedule_id: null
      }];
    });
    
  }, [all_vehicle, current_route, activeTab, retrievedData, tripdata, selectedDate]);
*
const filteredVehicles = useMemo(() => {
  if (!all_vehicle || !current_route || !selectedDate) return [];

  const selectedDateObj = new Date(selectedDate);

  
//  const today = new Date();
  //const cutoffDate = new Date();
  //cutoffDate.setDate(today.getDate() + 10);

   //if (selectedDateObj > cutoffDate) {
   // console.log("Selected date is beyond 10 days → no vehicles shown");
   // return [];
  //}
  
  // Base vehicle filtering
  const baseFiltered = all_vehicle.filter(car => {
    // Check date-based unavailability
    const isDateUnavailable = () => {
      if (!car.not_available?.from) return false;

      const fromDate = new Date(car.not_available.from);
      const toDate = car.not_available.to ? new Date(car.not_available.to) : null;

      // Handle invalid date ranges
      if (toDate && fromDate > toDate) {
        console.warn(`⚠ Invalid not_available range for car: ${car.brand_name}, fromDate, toDate`);
        return false;
      }

      // Indefinite unavailability (no "to" date)
      if (!toDate) return selectedDateObj >= fromDate;

      // Unavailable between two dates
      return selectedDateObj >= fromDate && selectedDateObj <= toDate;
    };

    const unavailableByDate = isDateUnavailable();
    const unavailableByToggle = !!car.isUnavailable; // Boolean toggle

    // Debug
   /* console.log(
      "Car:", car.brand_name,
      "| From:", car.not_available?.from,
      "| To:", car.not_available?.to,
      "| Toggle Unavailable:", unavailableByToggle,
      "| Date Unavailable:", unavailableByDate
    );*

    
    //if (unavailableByToggle || unavailableByDate) return false;

    // Priority-based filtering
if (unavailableByToggle) return false; // toggle ON = unavailable
if (unavailableByDate) return false;   // only checked if toggle is OFF


    // Route match
    const sameRoute = Array.isArray(car?.route_id) && (
      car.route_id.includes(current_route?._id) ||
      car.route_id.some(r => r?._id === current_route?._id)
    );

    // Category match
    const categoryMatch = car.category === retrievedData?.seats;

    if (activeTab === "shared") {
      const sharedCab = car?.cab_available_for === 'Shared-cab' || car?.cab_available_for === 'Both';
      return sameRoute && categoryMatch && sharedCab;
    } else {
      const fullCab = car?.cab_available_for === 'Full-Cab' || car?.cab_available_for === 'Both';
      const assigned = tripdata.some(
        trip => trip.vehicleId === car._id && trip.route === current_route._id
      );
      return sameRoute && !assigned && fullCab && categoryMatch;
    }
  });

  // Expand vehicles by their schedules
  return baseFiltered.flatMap(car => {
    if (Array.isArray(car.selected_schedules) && car.selected_schedules.length > 0) {
      return car.selected_schedules
        .filter(routeSchedule => {
          const route = routeSchedule?.route;
          return (
            route === current_route._id ||
            route?._id === current_route._id
          );
        })
        .flatMap(routeSchedule => {
          const routeId = routeSchedule?.route?._id || routeSchedule?.route;

          if (
            Array.isArray(routeSchedule.schedules) &&
            typeof routeSchedule.schedules[0] === 'object'
          ) {
            return routeSchedule.schedules.map(schedule => ({
              ...car,
              route_id: routeId,
              schedule_time: schedule.start,
              schedule_id: schedule._id
            }));
          }

          return routeSchedule.schedules.map(scheduleId => ({
            ...car,
            route_id: routeId,
            schedule_time: null,
            schedule_id: scheduleId
          }));
        });
    }

    return [{
      ...car,
      schedule_time: car.time,
      schedule_id: null
    }];
  });

}, [all_vehicle, current_route, activeTab, retrievedData, tripdata, selectedDate]);

  // Sort vehicles
  const sortedVehicles = useMemo(() => {
    const items = [...filteredVehicles];
    if (!sortConfig.key) return items;

    items.sort((a, b) => {
      if (sortConfig.key === "price") {
        const aP = activeTab === "shared" ? getprice(a) : getprice_for_fullcabs(a);
        const bP = activeTab === "shared" ? getprice(b) : getprice_for_fullcabs(b);
        return sortConfig.direction === "ascending" ? aP - bP : bP - aP;
      }
      if (sortConfig.key === "seats") {
        const aS = a.seats.length, bS = b.seats.length;
        return sortConfig.direction === "ascending" ? aS - bS : bS - aS;
      }
      if (sortConfig.key === "time") {
        const tA = new Date(`1970-01-01T${a.schedule_time}`);
        const tB = new Date(`1970-01-01T${b.schedule_time}`);
        return sortConfig.direction === "ascending" ? tA - tB : tB - tA;
      }
      return 0;
    });
    return items;
  }, [filteredVehicles, sortConfig, getprice, getprice_for_fullcabs, activeTab]);

  const requestSort = (key) => {
    const direction =
      sortConfig.key === key && sortConfig.direction === "ascending"
        ? "descending"
        : "ascending";
    setSortConfig({ key, direction });
  };

  const getSortIndicator = (key) =>
    sortConfig.key !== key ? "⇵" : sortConfig.direction === "ascending" ? "▲" : "▼";

  const convertTime = (kms) => {
    if (!kms) return "0 hours";
    const totalHours = (kms * 0.75) / 60;
    const h = Math.floor(totalHours),
      m = Math.round((totalHours - h) * 60);
    return m === 0 ? `${h} ${h === 1 ? "hr" : "hrs"}` : `${h} ${h === 1 ? "hr" : "hrs"} ${m} min`;
  };

  const convertDateFormat = (d) => {
    const dt = new Date(d);
    return `${String(dt.getDate()).padStart(2, "0")}/${String(
      dt.getMonth() + 1
    ).padStart(2, "0")}/${dt.getFullYear()}`;
  };
  const formatTime = (timeStr) => {
  if (!timeStr) return "";
  try {
    const [hours, minutes] = timeStr.split(":").map(Number);
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  } catch {
    return timeStr;
  }
};

const searchedVehicles = useMemo(() => {
  if (!searchTerm) return sortedVehicles;
  return sortedVehicles.filter((car) =>
    `${car.brand_name} ${car.model_name} ${car.reg_no}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );
}, [sortedVehicles, searchTerm]);


  return (
    <div className="flex flex-col lg:flex-row gap-4 px-0 lg:px-16 py-6 mt-48 md:mt-32 mb-[5rem] font-lato">
      <div className="w-full lg:w-3/4 bg-white bg-opacity-80 backdrop-blur-lg shadow-lg p-6 rounded-lg order-2 lg:order-1">
        <div className="flex flex-wrap justify-center gap-4 mb-6 -mt-4">
          <button
              onClick={() => setActiveTab("shared")}
            className={`px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium transition-all duration-300 shadow-md text-sm sm:text-base ${activeTab === "shared"
              ? "bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-lg transform scale-105"
              : "bg-gray-300 text-gray-700 hover:bg-gradient-to-r hover:from-gray-400 hover:to-gray-500 hover:text-white"
              }`}>
            Shared Cabs
          </button>
          <button
            onClick={() => setActiveTab("full")}
            className={`px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium transition-all duration-300 shadow-md text-sm sm:text-base ${activeTab === "full"
              ? "bg-gradient-to-r from-indigo-500 to-purple-600 text-white shadow-lg transform scale-105"
              : "bg-gray-300 text-gray-700 hover:bg-gradient-to-r hover:from-gray-400 hover:to-gray-500 hover:text-white"
              }`}>
            Reserve Cabs
          </button>
        </div>
         {/* 🔍 Search bar *
        <div className="relative w-full sm:w-1/2 md:w-1/3 mb-4">
  <input
    type="text"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    placeholder="Search by brand, model, or reg no"
    className="w-full px-4 py-2 border rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-400"
  />
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="absolute right-3 top-2.5 h-5 w-5 text-gray-500"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1110.5 3a7.5 7.5 0 016.15 13.65z"
    />
  </svg>
</div>

        <div className="w-full flex flex-wrap justify-between bg-gray-100 shadow-md rounded-md p-3 text-center">
          {[
            { key: "seats", label: "Seats" },
            { key: "price", label: "Fare" },
            { key: "time", label: "Departure" },
          ].map((header) => (
            <div
              key={header.key}
              onClick={() => requestSort(header.key)}
              className="flex-1 text-gray-700 font-semibold uppercase text-xs sm:text-sm cursor-pointer flex justify-center items-center hover:text-indigo-600 transition-all">
              {header.label}
              <span className="ml-1">{getSortIndicator(header.key)}</span>
            </div>
          ))}
        </div>


          {(activeTab === "shared" && !sharedEnabled) || (activeTab === "full" && !reservedEnabled) ? (
          <div className="text-center py-8">
            <p className="text-gray-600 text-lg font-medium">
              {activeTab === "shared" ? "Shared Cabs" : "Reserved Cabs"} are temporarily unavailable
            </p>
            <p className="text-gray-500 text-sm mt-2">
              Please check back later or try another option
            </p>
          </div>
        ) : searchedVehicles.length ? (
          searchedVehicles.map((car) => (
            <div
              key={`${car._id}-${car.schedule_id || "default"}`}
              className="bg-white bg-opacity-90 backdrop-blur-md rounded-lg shadow-lg p-5 my-4 flex flex-col md:flex-row gap-6 border border-gray-200 hover:shadow-xl transition-all">
              <img
                src={car.picture_of_the_vehicle}
                alt={`${car?.brand_name ?? ''} ${car?.model_name ?? ''}`}

                className="w-full md:w-1/3 h-48 object-cover rounded-lg shadow-md"
              />
              <div className="flex flex-col md:flex-row justify-between w-full">
                <div className="flex-grow text-center md:text-left">
                  
                  <h3 className="text-lg sm:text-xl font-bold text-gray-800">
                    {car.brand_name + ' ' + car.model_name}

                  </h3>
                   <h5 className="text-sm sm:text-md font-bold text-gray-600">
                    Register No: {car.reg_no}

                  </h5>
                  <p className="text-gray-600 text-sm sm:text-base">
                    {car.seats.length} Seater
                  </p>
                  <ul className="text-gray-500 text-xs sm:text-sm mt-2">
                    {car.features?.map((feature, i) => (
                      <li key={i}>• {feature}</li>
                    ))}
                  </ul>
                </div>
                <div className="flex flex-col items-center justify-center text-center w-full md:w-1/3">
                  <h1 className="text-md sm:text-lg font-semibold text-indigo-600">
                    {convertDateFormat(retrievedData.date)}
                  </h1>
      <h4 className="text-gray-500 text-xs sm:text-sm">
  {car.schedule_time
    ? `Departure: ${formatTime(car.schedule_time)}`
    : "No schedule available"}
</h4>
  {/* Dropdown for schedules *
{ /*} {car.schedules.length > 0 ? (
    <select
      className="border px-2 py-1 rounded mt-2"
      onChange={(e) => car.selectedSchedule = e.target.value}
      defaultValue=""
    >
      <option value="" disabled>Select Schedule</option>
      {car.schedules.map(sch => (
        <option key={sch.id} value={sch.id}>
          {sch.time ? formatTime(sch.time) : "No time available"}
        </option>
      ))}
    </select>
  ) : (
    <p className="text-gray-500 text-xs">No schedules available</p>
  )} *

                  <p className="bg-blue-200 text-blue-600 px-2 sm:px-3 py-1 mt-3 rounded-full font-semibold text-xs sm:text-sm">
                    Duration: {current_route?.duration || "Not specified"}
                  </p>
                </div>
                <div className="flex flex-col items-center md:items-end justify-between text-center md:text-right mt-4 md:mt-0">
                  <p className="text-xl sm:text-2xl font-bold text-green-500">
                    ₹{activeTab === "shared" ? Math.round(getprice(car)) : Math.round(getprice_for_fullcabs(car))}/-
                  </p>
                  <button
      onClick={() => {
  try {
    const existingBooking = JSON.parse(localStorage.getItem("Selected Data"));

    // find selected schedule
  //  const scheduleId = car.selectedSchedule;
   // if (!scheduleId) {
   //   alert("Please select a schedule before booking");
   //   return;
   // }

   // const selectedSchedule = car.schedules.find(s => s.id === scheduleId);
    let time = car.schedule_time;

    if (!time) throw new Error("Schedule time is missing");
    if (time.length === 5) time += ":00";

    const rawDate = existingBooking.date?.split("T")[0];
    const fullDateTime = `${rawDate}T${time}`;
    const fullDateObj = new Date(fullDateTime);

    if (isNaN(fullDateObj.getTime())) {
      alert("Invalid date or time format");
      return;
    }

    const updatedBooking = {
      ...existingBooking,
      date: fullDateObj.toISOString(),
    //  schedule_id: scheduleId,
    };

    localStorage.setItem("Selected Data", JSON.stringify(updatedBooking));

    const path = activeTab === "shared" ? `/Seats/${car._id}` : `/fullcabbook/${car._id}`;
    navigate(path);
  } catch (err) {
    console.error("Booking error:", err);
    alert("Something went wrong while booking. Please try again.");
  }
}}

                    className="mt-4 bg-gradient-to-r from-blue-400 to-blue-500 text-white py-2 px-4 sm:px-5 rounded-md shadow-lg hover:from-green-500 hover:to-green-700 transition-all"
                  >
                    {activeTab === "shared" ? "Select Seat" : "Book Full Cab"}
                  </button>


                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center py-8">
            <p className="text-gray-600 text-lg font-medium">
              No {activeTab === "shared" ? "shared" : "full"} vehicles available on this route
            </p>
            <p className="text-gray-500 text-sm mt-2">
              Please try different filters or check back later
            </p>
          </div>
        )}
      </div>
      <div className="w-full lg:w-1/4 rounded-lg p-4 order-1 lg:order-2">
        <TripDetailsCard />
      </div>
    </div>
  );
};

export default CarList;


*/




